// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Permission Elevation API
 * API for engineers to elevate and de-elevate their permissions within Aura.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumAccessType } from './EnumAccessType';
import {
  EnumAccessTypeFromJSON,
  EnumAccessTypeFromJSONTyped,
  EnumAccessTypeToJSON,
  EnumAccessTypeToJSONTyped,
} from './EnumAccessType';

/**
 *
 * @export
 * @interface MainUserAccessResponse
 */
export interface MainUserAccessResponse {
  /**
   *
   * @type {Array<EnumAccessType>}
   * @memberof MainUserAccessResponse
   */
  allowedLevels?: Array<EnumAccessType>;
  /**
   *
   * @type {string}
   * @memberof MainUserAccessResponse
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof MainUserAccessResponse
   */
  subject?: string;
}

/**
 * Check if a given object implements the MainUserAccessResponse interface.
 */
export function instanceOfMainUserAccessResponse(
  value: object,
): value is MainUserAccessResponse {
  return true;
}

export function MainUserAccessResponseFromJSON(
  json: any,
): MainUserAccessResponse {
  return MainUserAccessResponseFromJSONTyped(json, false);
}

export function MainUserAccessResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MainUserAccessResponse {
  if (json == null) {
    return json;
  }
  return {
    allowedLevels:
      json['allowedLevels'] == null
        ? undefined
        : (json['allowedLevels'] as Array<any>).map(EnumAccessTypeFromJSON),
    email: json['email'] == null ? undefined : json['email'],
    subject: json['subject'] == null ? undefined : json['subject'],
  };
}

export function MainUserAccessResponseToJSON(
  json: any,
): MainUserAccessResponse {
  return MainUserAccessResponseToJSONTyped(json, false);
}

export function MainUserAccessResponseToJSONTyped(
  value?: MainUserAccessResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    allowedLevels:
      value['allowedLevels'] == null
        ? undefined
        : (value['allowedLevels'] as Array<any>).map(EnumAccessTypeToJSON),
    email: value['email'],
    subject: value['subject'],
  };
}
